// Quem pode ler cada número da Central. Espelha as policies do backend: sem
// isso o Hub pedia campanhas, relatório do Kanban e fluxos para todo mundo, e
// o agente levava três 401 por visita (visto em staging em 25/09/2026).
//   campanhas         CampaignPolicy#index?                 admin ou campaigns_view
//   relatório Kanban  KanbanItemPolicy#reports?             admin ou report_manage
//   fluxos            ConversationWorkflowPolicy#index?     só admin
// A lista de permissões da conta já traz 'administrator' ou 'agent' junto
// das permissões do papel customizado.
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';

export const HUB_DATA_PERMISSIONS = {
  campaigns: ['administrator', 'campaigns_view'],
  kanbanReports: ['administrator', 'report_manage'],
  flows: ['administrator'],
};

export const hubDataAccess = (permissions = []) => ({
  campaigns: hasPermissions(HUB_DATA_PERMISSIONS.campaigns, permissions),
  kanbanReports: hasPermissions(
    HUB_DATA_PERMISSIONS.kanbanReports,
    permissions
  ),
  flows: hasPermissions(HUB_DATA_PERMISSIONS.flows, permissions),
});

export function useHubDataAccess() {
  const currentUser = useMapGetter('getCurrentUser');
  const accountId = useMapGetter('getCurrentAccountId');
  return computed(() =>
    hubDataAccess(
      currentUser.value?.accounts
        ? getUserPermissions(currentUser.value, accountId.value)
        : []
    )
  );
}
